import FamilyMembersInformation from './FamilyMembersInformation'

const SixthPage = FamilyMembersInformation

export default SixthPage
